import React from "react";
import { ShieldAlert, PhoneCall } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Disclaimer */}
        <div
          data-testid="crisis-disclaimer"
          className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-6 sm:p-7 flex flex-col sm:flex-row gap-4 sm:items-start"
        >
          <div className="h-10 w-10 rounded-full bg-amber-500/15 text-amber-300 flex items-center justify-center shrink-0">
            <ShieldAlert size={18} />
          </div>
          <div className="text-sm leading-relaxed text-slate-200">
            <p className="font-heading text-base text-amber-200">
              A gentle, important note.
            </p>
            <p className="mt-2">
              Ask Chaplain Derrick provides faith-based encouragement, spiritual
              reflection, education, and practical support. It is not a
              substitute for licensed medical, mental health, legal, financial,
              or emergency crisis care. If you are in crisis, call{" "}
              <a
                href="tel:988"
                data-testid="crisis-call-link"
                className="inline-flex items-center gap-1 text-amber-300 hover:text-amber-200 font-semibold"
              >
                <PhoneCall size={12} /> 988
              </a>{" "}
              or seek immediate professional help.
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-white text-[#0369A1] font-heading">
                D
              </span>
              <span className="font-heading text-xl text-white">
                Ask Chaplain Derrick
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-md">
              A podcast, book, and teaching platform offering practical
              encouragement for life&apos;s difficult seasons — welcoming to
              both faith-based and non-religious audiences.
            </p>
            <p className="mt-3 text-xs text-slate-500 max-w-md">
              In partnership with{" "}
              <span className="text-slate-300">Begin Again Living Ministries</span>{" "}
              and friendly to <span className="text-slate-300">California Corporate Chaplains</span> outreach.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-widest text-slate-500">
              Explore
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#about" className="hover:text-white">About</a></li>
              <li><a href="#podcast" className="hover:text-white">Podcast</a></li>
              <li><a href="#book" className="hover:text-white">Book</a></li>
              <li><a href="#classes" className="hover:text-white">Classes &amp; Workshops</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-widest text-slate-500">
              Connect
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#submit" className="hover:text-white">Submit a Question</a></li>
              <li><a href="#speaking" className="hover:text-white">Invite Chaplain Derrick</a></li>
              <li>
                <a href="mailto:office@balministries.org" className="hover:text-white">
                  office@balministries.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Ask Chaplain Derrick. All rights reserved.</p>
          <p>Real Questions. Honest Answers. Practical Hope.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
